import { Tooltip } from "@mui/material";
import { RemoteExecutionIcon } from "~/icons";

export function RemoteExploitIcon() {
  return (
    <Tooltip title="Remote Execution" placement="top" arrow>
      <RemoteExecutionIcon
        sx={{ color: (theme) => theme.palette.text.warning }}
      />
    </Tooltip>
  );
}
